import {types} from 'mobx-state-tree';
import {extraMenu} from '../menu';
import CompanyService from '../services/CompanyService';
import {rootStore} from '.';

// 개인 연차 정보
const restInfo = types
    .model({
        extraRestDay: types.optional(types.number, 0),
		joinDate: types.optional(types.string, ''),
		joinYear: types.optional(types.number, 0),
		lastdate: types.optional(types.string, ''),
		lastday: types.optional(types.number, 0),
		reqRest: types.optional(types.number, 0),
		rest: types.optional(types.number, 0),
		restM: types.optional(types.number, 0),
		//restTable: types.optional(types.array, []),
		restY: types.optional(types.number, 0),
		resttype: types.optional(types.string, ''),
		resttype2: types.optional(types.number, 0),
		susRest: types.optional(types.number, 0),
		userest: types.optional(types.number, 0),
		reqMonthRest: types.optional(types.number, 0),
		susMonthRest: types.optional(types.number, 0),
    });

// 개인 조직 정보
const departInfo = types
	.model({
		departId: types.optional(types.number, 0),
		departName: types.optional(types.string, ''),		
		positionName: types.optional(types.string, ''),
		head: types.optional(types.boolean, false),
		main: types.optional(types.boolean, false),
	})

export const Company = types
	.model('Company', {
		id: types.optional(types.number, 0),
		uuid: types.maybeNull(types.string),
		name: types.maybeNull(types.string),
		tel: types.maybeNull(types.string),
		logo: types.maybeNull(types.string),
		address: types.maybeNull(types.string),		
		addressDetail: types.maybeNull(types.string),
		createdAt: types.maybeNull(types.string),
		udpatedAt: types.maybeNull(types.string),
		companyNumber: types.maybeNull(types.string),
		isAdmin: types.maybeNull(types.boolean),
		isDoc: types.maybeNull(types.boolean), // 사용자모드 OR 관리자모드
		isSetting: types.maybeNull(types.boolean),
		ownerUserId: types.maybeNull(types.number),
		companyPeriod: types.maybeNull(types.array(types.string)),
		restType: types.maybeNull(types.boolean),
		restDate: types.maybeNull(types.string),
		securityDevice: types.maybeNull(types.boolean),
		companyAnniversary: types.maybeNull(types.string),
   	 	locationInfo: types.optional(types.string, ''),
		logoBase64: types.maybe(types.string), // 로고 데이터
		logoChangeTime: types.optional(types.number, 0), // 로고 버전, 초기값 0
		
		// 회사 휴가 옵션
		restOptionMonth: types.maybeNull(types.string),
		restOptionYear: types.maybeNull(types.integer),
		restRoundYear: types.maybeNull(types.string),
		restOptionAdd: types.maybeNull(types.string),

		restDispUnit: types.maybeNull(types.string),
		restPromote: types.maybeNull(types.boolean),

		restInfo: types.optional(types.string, '{}'), // restInfo
		departInfos: types.optional(types.array(departInfo), []),	

		nickName: types.maybeNull(types.string),
		employType: types.maybeNull(types.string),

		userRank: types.maybeNull(types.string),
		userDepartment: types.maybeNull(types.string),
		approvalSelf: types.maybeNull(types.boolean), // 결재라인 회사 지정

		//연차설정
		restAccrualTransfer: types.maybeNull(types.boolean),
		restAccrualTransferMax : types.maybeNull(types.integer),
		restAccrualTransferAgree: types.maybeNull(types.boolean),
		restTransferAgreeDay : types.maybeNull(types.integer),
		restAccrualTransferRange: types.maybeNull(types.boolean),
		restAccrualTransferTarget : types.maybeNull(types.string),
		restAllowNegativeAccrual :  types.maybeNull(types.boolean),
		restNegativeAccrualMax : types.maybeNull(types.integer),
		restScheduleSelf: types.maybeNull(types.boolean),
		restRequestUnit: types.maybeNull(types.boolean),
		restRequestUnitMin: types.maybeNull(types.number),

		// 개인연차옵션 (미설정시 회사설정)
		userRestType: types.maybeNull(types.boolean),
    	userRestDate: types.maybeNull(types.string),
        userRestOptionYear: types.maybeNull(types.integer),
        userRestRoundYear: types.maybeNull(types.string),

		// 개인이월연차옵션 (미설정시 회사설정)
		userRestAccrualTransfer: types.maybeNull(types.boolean),
		userRestAccrualTransferMax : types.maybeNull(types.integer),
		userRestAccrualTransferAgree: types.maybeNull(types.boolean),
		userRestTransferAgreeDay: types.maybeNull(types.integer),
		userRestAccrualTransferTarget: types.maybeNull(types.string),

		organizationUnit: types.maybeNull(types.string),
		leaveRestrictionRate: types.maybeNull(types.integer),
		targetEmployeeScope: types.maybeNull(
			types.model({
				isManual: types.boolean,
				conditions: types.optional(
					types.array(
						types.model({
							scopeType: types.string,
							scopeValue: types.optional(
								types.array(types.number),
								[]
							),
						})
					),
					[]
				),
			})
		),
		secondNoticePeriod: types.maybeNull(types.integer),
		isSsoEnabled: types.maybeNull(types.boolean),
		noticeAutoSendScope: types.maybeNull(
			types.model({
				month: types.boolean,
				annual: types.boolean,
				labor: types.boolean
			})
		),
		annualPlanReqInfo: types.maybeNull(
			types.model({
				openType: types.string,
				openValue: types.number,
				allowFutureLeave: types.boolean
			})
		),

		// 근무정책
		isUseWorkplan: types.maybeNull(types.boolean),
		isUseWorkActual: types.maybeNull(types.boolean),
		workplanWSList: types.maybeNull(types.array(types.integer)),
		workplanWSNameList: types.maybeNull(types.array(types.string)),
		worktimeDispUnit: types.maybeNull(
			types.model({
				isPlan: types.boolean,
				tardiness: types.boolean,
				overtime: types.boolean
			})
		),
		isPersonalDeadline: types.maybeNull(types.boolean),
		personalDeadlineWSNameList: types.maybeNull(types.array(types.string)),
		afterDeadlineUpdate: types.maybeNull(types.boolean),
		deadlineUpdateRoleList: types.maybeNull(types.array(types.integer)),
		deadlineUpdateRoleNameList: types.maybeNull(types.array(types.string)),
		altHolidayScope: types.maybeNull(
			types.model({
				isManual: types.boolean,
				scopeValue: types.number,
				scopeUnit: types.string
			})
		),
		altHolidayMinimumHour: types.maybeNull(
			types.model({
				isManual: types.boolean,
				hour: types.number
			})
		),
		altHolidayHourInput: types.maybeNull(types.boolean),
		isUseCompensatoryLeave: types.maybeNull(types.boolean),
		compensatoryLeaveInfo: types.maybeNull(
			types.model({
				premiumRate: types.maybeNull(
					types.model({
						night: types.maybeNull(types.frozen()),
						holiday: types.maybeNull(types.frozen()),
						overtime: types.maybeNull(types.frozen())
					})
				),

				accrualScope: types.maybeNull(types.frozen()),

				employeeScope: types.maybeNull(
					types.model({
						isManual: types.maybeNull(types.frozen()),
						conditions: types.maybeNull(types.frozen())
					})
				),
				minimumAccrualUnit: types.maybeNull(
					types.model({
						hours: types.maybeNull(types.frozen()),
						isUse: types.maybeNull(types.frozen())
					})
				)
			})
		),
		attendanceIssueInfo: types.maybeNull( // 근태이상자
			types.model({
				autoAbsentYn: types.maybeNull(types.boolean),
				attendanceAlertTypes: types.maybeNull(
					types.model({
						late: types.maybeNull(types.boolean),
						early: types.maybeNull(types.boolean),
						absent:types.maybeNull(types.boolean),
						noClockOut: types.maybeNull(types.boolean),
					})
				),
				emailRecipientScope: types.maybeNull(
					types.model({
						isManual: types.maybeNull(types.boolean),
						conditions: types.optional(
							types.array(
								types.model({
									scopeType: types.string,
									scopeValue: types.optional(
										types.array(types.number),
										[]
									),
								})
							),
							[]
						)
					})
				)
			})
		),
	})
	.views((self) => ({
		get get() {
			return { ...self, restInfo: JSON.parse(self.restInfo) };
		},
	}))
	.actions((self) => ({
		setLogoBase64(value) { // MST 상태에 로고 Base64 데이터 업데이트
			self.logoBase64 = value;
			self.logoChangeTime = Date.now();
		},
		async selectCompany(id, mobileDesign, isAnnualPlan) {
			const response = await CompanyService.selectCompany(id);

			if(response.data?.id) {
				const logoResponse = await CompanyService.info({ id }); // 최신 로고 데이터 MST 상태에 반영

				self.setData(response.data);
				self.setLogoBase64(logoResponse.data.logoBase64); // 로고 데이터를 MST 상태에 저장
				self.setDepartInfo(response.data.departments);
				// 항상 사용자모드로 진입 (모바일/PC 구분 없음)
				self.setIsAdmin(false);

				// Reset Attendance data
				rootStore?.attend?.reset();

				// await Attend.setData();
			} else {
				window.location.replace(extraMenu.changeCompany.path);
			}
		},
		async getDepartInfo() {
			try { 
				const response = await CompanyService.selectCompany(self.id);
				self.setDepartInfo(response.data.departments)
			} catch (err) {

			}
		},
		async setRestInfo(data) {
			self.restInfo = JSON.stringify(data);
		},
		async setDepartInfo(data) {
			self.departInfos = data
		},
		async setData(data) {
			try {
				Object.keys(data || {}).forEach(key => {
					try {
						console.log('setData key:', key);

						if (data[key] !== undefined && data[key] !== null) {
							self[key] = data[key];
						}
					} catch (e) {
						console.error('setData 실패 key:', key, data[key], e);
					}
				});
			} catch (error) {
				console.error(error);
			}
		},
		async setIsAdmin(data) {
			self.isDoc = data;			
		},
		async setCompanyPeriod(data) {
			self.companyPeriod = data;
		},
		async logout() {
			self.id = 0;
			self.name = '';
			self.uuid = '';
			self.tel = '';
			self.logo = '';
			self.address = '';
			self.addressDetail = '';
			self.createdAt = '';
			self.udpatedAt = '';
			self.isAdmin = false;
			self.isDoc = false;
			self.isSetting = true;
			self.ownerUserId = 0;
			self.companyPeriod = ['', ''];
			self.securityDevice = false;
			self.companyNumber = '';
			self.employType = '';
			self.restOptionMonth = '';
			self.restOptionYear = 0;
			self.restRoundYear = 'ROUND';
			self.restOptionAdd = '';
			self.restUseUnit = 'HALF';
			self.restPromote = false;
			self.restScheduleSelf = false;
			self.restInfo = '{}';
			self.departInfos = [];
			self.nickName = '';
			self.userRank = '';
			self.userDepartment = '';
			self.userRestType = null;
			self.userRestDate = null;
			self.userRestOptionYear = null;
			self.userRestRoundYear = null;
			self.approvalSelf = false;
			self.userRestAccrualTransfer = false;
			self.userRestAccrualTransferMax = 0;
			self.userRestAccrualTransferAgree = false;
			self.userRestTransferAgreeDay = 0;
			self.userRestAccrualTransferTarget = '';
			self.isUseWorkplan = false;
			self.isUseWorkActual = true;
			self.workplanWSList = [];
			self.workplanWSNameList = [];
			self.workTimeDispUnit = null;
			self.isPersonalDeadline = false;
			self.personalDeadlineWSNameList = [];
			self.afterDeadlineUpdate = false;
			self.deadlineUpdateRoleList = [];
			self.deadlineUpdateRoleNameList = [];
			self.altHolidayScope = null;
			self.altHolidayMinimumHour = null;
			self.altHolidayHourInput = false;
			self.organizationUnit = '';
			self.leaveRestrictionRate = 0;
			self.targetEmployeeScope = null;
			self.secondNoticePeriod = 0;
			self.isSsoEnabled = false;
			self.noticeAutoSendScope = null;
			self.annualPlanReqInfo = null;
		},
	}));

/*
2023-12-06 16:10:45: tmp : {
  id: 8,
  userId: 5,
  uuid: null,
  name: '미유',
  tel: '1234',
  postCode: null,
  address: '서울 중구 다산로 지하 115 (신당동, 약수역 6호선)',
  addressDetail: '',
  restType: false,
  restDate: null,
  restOptionMonth: null,
  restDestoryMonth: true,
  restGraceMonth: 0,
  restOptionYear: 1,
  restRoundYear: 'ROUND',
  restDestoryYear: true,
  restGraceYear: 0,
  restUseUnit: 'HALF',
  restPromote: false,
  securityDevice: false,
  logo: '',
  ceoName: '',
  registrationNumber: '',
  corporationNumber: '',
  createdAt: 2023-12-06T06:16:11.733Z,
  companyAnniversary: 2023-12-06T06:16:11.733Z,
  approvalSelf: false,
  faxNumber: null,
  restAccrualTransfer: false,
  restAccrualTransferMax: 0,
  restAllowNegativeAccrual: false,
  restNegativeAccrualMax: 0,
  updatedAt: 2023-12-06T06:16:11.733Z,
  deletedAt: null,
  user_id: 5,
  restTypeList: [
    restday {
      dataValues: [Object],
      _previousDataValues: [Object],
      uniqno: 1,
      _changed: Set(0) {},
      _options: [Object],
      isNewRecord: false
    }
  ],
  roleName: '대표 관리자',
  permission: [ 'ADMIN' ],
  isAdmin: true,
  userCount: 1,
  role: {
    id: 21,
    companyId: 8,
    name: '대표 관리자',
    permission: [ 'ADMIN' ],
    permissions: { menuRole: [Object], basicRole: [Object], detailRole: [Object] },
    type: '',
    createdAt: 2023-12-06T06:16:11.747Z,
    updatedAt: 2023-12-06T06:16:11.747Z,
    deletedAt: null,
    company_id: 8
  },
  companyPeriod: [ '23.12.06', '24.01.06' ],
  ownerUserId: 5,
  admin: '',
  userRank: '대표이사',
  nickName: '',
  userDepartment: '',
  userRestType: false,
  userRestDate: null,
  userRestOptionYear: 1,
  userRestRoundYear: 'ROUND',
  heads: []
}
*/
